/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_BackInputs */

const en_project_back = /** @type {(inputs: Project_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All projects`)
};

const lv_project_back = /** @type {(inputs: Project_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visi darbi`)
};

/**
* | output |
* | --- |
* | "All projects" |
*
* @param {Project_BackInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_back = /** @type {((inputs?: Project_BackInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_BackInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_back(inputs)
	return en_project_back(inputs)
});